import { FC, ReactNode } from 'react'
import { GlobalStyled } from 'src/styles/global.styled'
import { themeGlobal } from 'src/styles/themes/themeGlobal'
import { ThemeProvider } from 'styled-components'
import rtlPlugin from 'stylis-plugin-rtl'
import { prefixer } from 'stylis'
import { CacheProvider } from '@emotion/react'
import createCache from '@emotion/cache'
import { ThemeProvider as ThemeProviderMui } from '@mui/material/styles'
import CustomToastContainer from '../toastContainer'
import { muiTheme } from 'src/styles/themes/muiTheme'
import { ConfirmProvider } from 'material-ui-confirm'

const defaultOptionsConfirm = { title: 'ایا مطمئنید؟', cancellationText: 'خیر', confirmationText: 'بله' }

const ConfigProviders: FC<{ children: ReactNode }> = ({ children }) => {
  const cacheRtl = createCache({
    key: 'muirtl',
    stylisPlugins: [prefixer, rtlPlugin],
  })

  return (
    <CacheProvider value={cacheRtl}>
      <ThemeProviderMui theme={muiTheme}>
        <ThemeProvider theme={themeGlobal}>
          <CustomToastContainer />
          <GlobalStyled />
          <ConfirmProvider defaultOptions={defaultOptionsConfirm}>
            {children}
          </ConfirmProvider>
        </ThemeProvider>
      </ThemeProviderMui>
    </CacheProvider>
  )
}

export default ConfigProviders
